module.exports = __webpack_public_path__ + "static/media/icon-dashboard-sales.09ce33ef.svg";